export const all = ['experienceDetail'] as const
export const detail = (offerId: string, currencyCode: string) =>
  [...all, offerId, currencyCode] as const

export const searchAll = ['experienceSearch'] as const
export const search = (query: string, region?: string) =>
  [...searchAll, query, region] as const
